// extracted by mini-css-extract-plugin
export var btn = "P_mB z_tp z_s1 d_bz d_bP d_bD d_dw";
export var full = "P_wP d_w d_H";
export var hoverStyle = "P_mF";
export var zoom = "P_mG";